module.exports = __webpack_public_path__ + "img/19.8f272cfe.svg";